export const productListTemplateSlots: keyString = {
  PLPLeftRefinements: 'left',
  ProductListSlot: 'right',
};

export const slotPositions: keyString = {
  LEFT: 'left',
  RIGHT: 'right',
};

export interface keyString {
  [key: string]: string;
}
